module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-unten_white-640fcd49b86ad9a18f1866b317e11b48.svg";